import { useQuery, QueryObserverOptions } from 'react-query';
import { Environment, HTTPError } from 'types';
import { getQueryAsync } from 'api/api-client';

const getEnvironments = async () => {
    return getQueryAsync(`/Environments`);
};

export default function useEnvironments(
    options?: QueryObserverOptions<Environment[], HTTPError>
) {
    return useQuery<Environment[], HTTPError>(
        ['Environments'],
        getEnvironments,
        {
            ...options,
            refetchOnWindowFocus: false
        }
    );
}
